import { Storage } from '@aws-amplify/storage'
import store from '@/store/index'

async function setAuthHeader() {
	await store.dispatch('getSession')
	Storage.configure({
		customPrefix: {
			public: 'restricted/'
		}
	})
}

var globalFolder // PAC or TWEG, "main folder"
var collection // Active group of files, "subfolder"

async function getS3Path(key) {
	const result = await Storage.get(key)
	return result
}


const FileService = {
	setGlobalFolder: async folder => {
		globalFolder = folder
	},

	setCollection: coll => {
		collection = coll
	},

	getCollections: async () => {
		await setAuthHeader()

		let result = await Storage.list(`${globalFolder}/`) // PAC/TEWG

		const collections = result
			.filter(entry => (entry.size ? false : true))
			.filter(entry => entry.key != globalFolder)
			.filter(entry => entry.key != `${globalFolder}/`)
			.map(entry => entry.key.replace(`${globalFolder}/`, '').slice(0, -1)) // Remove collection name from collection title, and strip trailing slash

		return collections
	},

	removeCollection: async collection => {
		await setAuthHeader()
		let result = await Storage.remove(`${globalFolder}/${collection}/`)
		return result
	},

	getFiles: async _collection => {
		await setAuthHeader()

		// Set active collection. This is needed in order for file upload
		// to know which location to insert new file
		collection = _collection

		let result = await Storage.list(`${globalFolder}/${collection}`)

		var files = result
			.filter(entry => (entry.size ? true : false))
			.filter(entry => entry.key != globalFolder)
			.filter(entry => entry.key != `${globalFolder}/`)
			.map(entry => {
				entry.title = entry.key.replace(`${globalFolder}/${collection}/`, '')
				return entry
			}) // Remove collection name from collection title

		files = await Promise.all(files.map(async file => {
			// Get a signed S3 URL for accessing files
			file.path = await getS3Path(file.key)
			return file
		}))

		return files
	},

	createCollection: async title => {
		await setAuthHeader()

		let result = await Storage.put(`${globalFolder}/${title}/`)
		// TODO: Generate and upload metadata file ?
		return result
	},

	downloadFile: async key => {
		await setAuthHeader()
		let result = await Storage.get(key)
		window.open(result, '_blank')
	},

	downloadFileBlob: async file => {
		const result = await Storage.get(file.key, { download: true })
		const blob = result.body

		downloadBlob(blob, file.name)
	},

	removeFile: async key => {
		await setAuthHeader
		let result = await Storage.remove(key)
		return result
	},

	uploadFile: async (title, file) => {
		const filetype = file.type
		const size = file.size / 1000 // convert bytes to megabytes

		try {
			// Make sure AWS Credentials are loaded
			await setAuthHeader()

			const fileKey = `${globalFolder}/${collection}/${file.name}`
			const { key } = await Storage.put(fileKey, file)

			title = key.replace(`${globalFolder}/${collection}/`, '')

			return {
				key,
				title,
				filetype,
				size
			}

		} catch (error) {
			throw error
		}
	},
}

export default FileService